/**
 * 将 v-button 组件样式渲染为 PNG（普通态 + 可选按压态）
 */
function parseColor(color, fallback = '#409eff') {
  if (!color || color === 'none') return fallback;
  return color;
}

function drawRoundRect(ctx, x, y, w, h, r) {
  const radius = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + w - radius, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
  ctx.lineTo(x + w, y + h - radius);
  ctx.quadraticCurveTo(x + w, y + h, x + w - radius, y + h);
  ctx.lineTo(x + radius, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
}

function renderButtonCanvas(component, options = {}) {
  const pressed = !!options.pressed;
  const style = component.style || {};
  const scale = 2;
  const width = Math.max(40, style.width || 100);
  const height = Math.max(24, style.height || 34);
  const canvas = document.createElement('canvas');
  canvas.width = width * scale;
  canvas.height = height * scale;
  const ctx = canvas.getContext('2d');
  ctx.scale(scale, scale);

  const bg = pressed
    ? parseColor(style.pressBackgroundColor, '#ffff00')
    : parseColor(style.backgroundColor, '#409eff');
  const color = parseColor(style.color, '#ffffff');
  const radius = style.borderRadius != null ? style.borderRadius : 0;

  ctx.fillStyle = bg;
  if (radius > 0) {
    drawRoundRect(ctx, 0, 0, width, height, radius);
    ctx.fill();
  } else {
    ctx.fillRect(0, 0, width, height);
  }

  const text = component.propValue || '';
  if (text) {
    ctx.fillStyle = color;
    ctx.font = `${style.fontWeight || 500} ${style.fontSize || 14}px sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, width / 2, height / 2);
  }

  const base64 = canvas.toDataURL('image/png').replace(/^data:image\/png;base64,/, '');
  return {
    base64,
    dataUrl: canvas.toDataURL('image/png'),
    fileName: `${(style.alias || 'button').replace(/[^\w\u4e00-\u9fa5-]/g, '_')}${pressed ? '-press' : ''}.png`,
    width,
    height,
    pressed,
  };
}

export async function renderButtonToImages(component, options = {}) {
  if (!component || component.component !== 'v-button') {
    throw new Error('仅支持 v-button 组件');
  }
  const images = [renderButtonCanvas(component, { pressed: false })];
  if (options.includePress !== false) {
    images.push(renderButtonCanvas(component, { pressed: true }));
  }
  return images;
}

export default renderButtonToImages;
